// extracted by css-extract-rspack-plugin
export default {"message":"QXVSJfj43oYZGpin"};